import React from 'react';
import { TextField } from '@mui/material';

export default function ToolParserField({ value, onChange, disabled = false }) {
  return (
    <TextField
      label='Tool Parser (override)'
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  );
}

